const training_pt = require('./training.json')
export default training_pt